import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_FETCH_VALIDATE_GROUP_BEGIN,
  MANAGE_SUBS_FETCH_VALIDATE_GROUP_SUCCESS,
  MANAGE_SUBS_FETCH_VALIDATE_GROUP_FAILURE,
  MANAGE_SUBS_FETCH_VALIDATE_GROUP_DISMISS_ERROR,
} from './constants';

export function fetchValidateGroup(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_VALIDATE_GROUP_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/validateGroup`,args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_FETCH_VALIDATE_GROUP_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_VALIDATE_GROUP_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchValidateGroupError() {
  return {
    type: MANAGE_SUBS_FETCH_VALIDATE_GROUP_DISMISS_ERROR,
  };
}

export function useFetchValidateGroup() {
  const dispatch = useDispatch();

  const { fetchValidateGroupPending, fetchValidateGroupError } = useSelector(
    state => ({
      fetchValidateGroupPending: state.manageSubs.fetchValidateGroupPending,
      fetchValidateGroupError: state.manageSubs.fetchValidateGroupError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchValidateGroup(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchValidateGroupError());
  }, [dispatch]);

  return {
    fetchValidateGroup: boundAction,
    fetchValidateGroupPending,
    fetchValidateGroupError,
    dismissFetchValidateGroupError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_VALIDATE_GROUP_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchValidateGroupPending: true,
        fetchValidateGroupError: null,
      };

    case MANAGE_SUBS_FETCH_VALIDATE_GROUP_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchValidateGroupPending: false,
        fetchValidateGroupError: null,
      };

    case MANAGE_SUBS_FETCH_VALIDATE_GROUP_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchValidateGroupPending: false,
        fetchValidateGroupError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_VALIDATE_GROUP_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchValidateGroupError: null,
      };

    default:
      return state;
  }
}
